import gql from 'graphql-tag';

export default gql`
    query GetBoxesToEdit {
        getBoxesToEdit {
            boxId
            boxDesc
        }
    }
`;
